// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hq-jobs[data-v-3f67779c]{margin-bottom:9.375rem}ul[data-v-3f67779c]{list-style:none;padding:0}.title[data-v-3f67779c]{-webkit-transform:translate(0%, -50%);transform:translate(0%, -50%)}@media only screen and (min-width: 600px){.title[data-v-3f67779c]{-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}}", ""]);
// Exports
module.exports = exports;
